// src/pages/Blog.js
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { db } from "../lib/firebase";
import { collection, getDocs } from "firebase/firestore";

export default function Blog() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      const snap = await getDocs(collection(db, "posts"));
      const items = snap.docs.map(d => ({ id: d.id, ...d.data() }));
      items.sort((a,b) => (b?.publishedAt?.toMillis?.()||0) - (a?.publishedAt?.toMillis?.()||0));
      setPosts(items);
      setLoading(false);
    })();
  }, []);

  return (
    <section style={{ maxWidth:960, margin:"90px auto", padding:"0 18px", color:"#e9eef5" }}>
      <h1 style={{ color:"#ffd13b" }}>Monkilla Blog</h1>
      {loading && <p>Loading…</p>}
      {!loading && posts.length === 0 && <p>No posts yet.</p>}
      <div style={{ display:"grid", gap:18 }}>
        {posts.map(p => {
          const slug = p.slug || p.id;
          return (
            <article key={slug} style={{ background:"rgba(14,18,24,.72)", border:"1px solid rgba(255,209,59,.25)", borderRadius:12, padding:16 }}>
              <h2 style={{ marginTop:0 }}>{p.title || slug}</h2>
              <p>{p.excerpt}</p>
              <Link to={`/blog/${slug}`} style={{ background:"#ffd13b", color:"#0b0f14", padding:"8px 12px", borderRadius:999, textDecoration:"none", fontWeight:800 }}>
                Read More →
              </Link>
            </article>
          );
        })}
      </div>
    </section>
  );
}
